var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadFaceFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM1.04342 6C1.04342 8.73744 3.26256 10.9566 6 10.9566C8.73744 10.9566 10.9566 8.73744 10.9566 6C10.9566 3.26256 8.73744 1.04342 6 1.04342C3.26256 1.04342 1.04342 3.26256 1.04342 6Z",
    fill: "#027BFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 4.75,
    r: 0.75,
    fill: "#027BFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 4.75,
    r: 0.75,
    fill: "#027BFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48029 8.75C3.21503 8.75 2.99608 8.53362 3.03836 8.27176C3.0754 8.04241 3.13904 7.81759 3.22836 7.60195C3.37913 7.23797 3.6001 6.90726 3.87868 6.62868C4.15726 6.3501 4.48797 6.12913 4.85195 5.97836C5.21593 5.8276 5.60603 5.75 6 5.75C6.39397 5.75 6.78407 5.8276 7.14805 5.97836C7.51203 6.12913 7.84274 6.3501 8.12132 6.62868C8.3999 6.90726 8.62087 7.23797 8.77164 7.60195C8.86096 7.81759 8.9246 8.04241 8.96164 8.27176C9.00392 8.53362 8.78497 8.75 8.51971 8.75C8.25446 8.75 8.04502 8.53207 7.98313 8.27414C7.95824 8.17041 7.9252 8.06856 7.88418 7.96955C7.78169 7.72211 7.63147 7.49729 7.44209 7.30791C7.25271 7.11853 7.02789 6.96831 6.78045 6.86582C6.53302 6.76333 6.26782 6.71057 6 6.71057C5.73218 6.71057 5.46698 6.76333 5.21955 6.86582C4.97211 6.96831 4.74729 7.11853 4.55791 7.30791C4.36853 7.49729 4.21831 7.72211 4.11582 7.96955C4.0748 8.06856 4.04176 8.17041 4.01687 8.27414C3.95498 8.53207 3.74554 8.75 3.48029 8.75Z",
    fill: "#027BFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceFeedback);
export default __webpack_public_path__ + "static/media/sad-face-feedback.8a7763e3c0b5de6c703284f7ac987008.svg";
export { ForwardRef as ReactComponent };